import React from 'react';
import { Typography, Grid, Badge } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import MediaPickersConstants from '../MediaPickersConstants';

const styles = theme => ({
    toggleButton: {
        background: theme.palette.background.paperDark,
        transition: theme.transitions.create('background', {
			easing: theme.transitions.easing.easeInOut,
			duration: theme.transitions.duration.shortest,
		})
    }
});

const MediaPickerTabBadge = withStyles(Badge,{
    badge: {
        fontSize: '0.65rem',
        right: 0,
        top: -10
    }
});

const MediaPickerTabs = (props) => {
    const { classes, selectedTab, onTabChange, enabledTabs, userAuthenticated } = props;

    return (
        <Grid>
            <ToggleButtonGroup
                value={selectedTab}
                exclusive
                onChange={onTabChange}
            >
                {enabledTabs.includes(MediaPickersConstants.MEDIA_PICKER_TABS.IMAGES) &&
                    <ToggleButton 
                        value={MediaPickersConstants.MEDIA_PICKER_TABS.IMAGES} 
                        aria-label='Search Images'
                        className={classes.toggleButton}
                    >
                        <Typography 
                            variant='button' 
                            color='textSecondary'
                        >
                            Images
                        </Typography>
                    </ToggleButton>
                }
                
                {enabledTabs.includes(MediaPickersConstants.MEDIA_PICKER_TABS.VIDEOS) &&
                    <ToggleButton 
                        value={MediaPickersConstants.MEDIA_PICKER_TABS.VIDEOS} 
                        aria-label='Videos'
                        className={classes.toggleButton}
                    >
                        <MediaPickerTabBadge 
                            badgeContent={'NEW'} 
                            color='primary'
                            invisible={(new Date()) > (new Date(MediaPickersConstants.BACKGROUND_CATALOG_VIDEOS_NEW_BADGE_TIMEOUT))}
                        >
                            <Typography 
                                variant='button'
                                color='textSecondary'
                            >
                                Videos
                            </Typography>
                        </MediaPickerTabBadge>
                    </ToggleButton>
                }

                {(enabledTabs.includes(MediaPickersConstants.MEDIA_PICKER_TABS.MY_ASSETS) && userAuthenticated) &&
                    <ToggleButton 
                        value={MediaPickersConstants.MEDIA_PICKER_TABS.MY_ASSETS} 
                        aria-label='My Assets'
                        className={classes.toggleButton}
                    >
                        <Typography 
                            variant='button'
                            color='textSecondary'
                        >
                            My Assets
                        </Typography>
                    </ToggleButton> 
                }
            </ToggleButtonGroup>
        </Grid>
    );
};

export default withStyles(MediaPickerTabs, styles);